import { render, staticRenderFns } from "./sortRankCharts.vue?vue&type=template&id=0480bfeb&scoped=true"
import script from "./sortRankCharts.vue?vue&type=script&lang=js"
export * from "./sortRankCharts.vue?vue&type=script&lang=js"
import style0 from "./sortRankCharts.vue?vue&type=style&index=0&id=0480bfeb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0480bfeb",
  null
  
)

export default component.exports